import { render, staticRenderFns } from "./bottomSelection.vue?vue&type=template&id=a781496c&scoped=true"
import script from "./bottomSelection.vue?vue&type=script&lang=js"
export * from "./bottomSelection.vue?vue&type=script&lang=js"
import style0 from "./bottomSelection.vue?vue&type=style&index=0&id=a781496c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a781496c",
  null
  
)

export default component.exports